// Layout Types

import PublicLayout from "../layout/PublicLayout";

// Route Views

import AboutUs from "../pages/aboutUs/AboutUs";
import { Faq } from "../pages/faq/Faq";
import PrivacyPolicy from "../pages/privacyPolicy/PrivacyPolicy";
import TermOfServices from "../pages/termOfServices/TermOfServices";
import CookiePolicy from "../pages/cookiePolicy/CookiePolicy";
import ContactUs from "../pages/contactUs/contactUs";
const commonRoutes = [
    {
        path: '/privacypolicy',
        exact: true,
        layout: PublicLayout,
        component: <PrivacyPolicy />
    },
    {
        path: '/termofservices',
        exact: true,
        layout: PublicLayout,
        component: <TermOfServices />
    },
    {
        path: '/faq',
        exact: true,
        layout: PublicLayout,
        component: <Faq />
    },
    {
        path: '/aboutus',
        exact: true,
        layout: PublicLayout,
        component: <AboutUs />
    },
    {
        path: '/cookiepolicy',
        exact: true,
        layout: PublicLayout,
        component: <CookiePolicy />
    },
    {
        path: '/contactus',
        exact: true,
        layout: PublicLayout,
        component: <ContactUs />
    },
];

export default commonRoutes;
